/**
 *  版权所有 © 2026 东方闻道 All Rights Reserved
 *
 *  创建者: admin
 *  创建时间: 2026-08-28 10:45
 *  文件名: src/components/ppt-learning-plan-viewer/word-viewer.tsx
 *  功能描述:
 */
import React from 'react';
import OfficeViewer from '../office-view';
import { useAsync } from 'eastedu-kit';
import { Spin } from 'antd';
import { getPreviewResources } from '../../redux/action/lesson.action';
import { LearningPlanPreviewContext } from './types';

interface WordViewerProps {
  fileId: string;
  previewContext: LearningPlanPreviewContext;
}

function WordViewer(props: WordViewerProps) {
  const { fileId, previewContext } = props;

  const fileResult = useAsync(async () => {
    return getPreviewResources(
      fileId,
      previewContext.type,
      encodeURIComponent(previewContext.wordFileName),
      previewContext,
    );
  }, [
    fileId,
    previewContext.type,
    previewContext.wordFileName,
    previewContext.resourceId,
    previewContext.courseId,
    previewContext.lessonId,
    previewContext.originalFileId,
    previewContext.documentId,
  ]);

  return (() => {
    if (fileResult.loading) {
      return (
        <Spin
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
          }}
        />
      );
    }

    if (fileResult.error) {
      return <span style={{ color: 'red' }}>获取word文件出错，请稍后再试！</span>;
    }

    const previewUrl = fileResult.result?.cdnUrl || fileResult.result?.url;
    if (!previewUrl) {
      return <span style={{ color: 'red' }}>未获获取到word文件预览地址</span>;
    }

    return <OfficeViewer url={previewUrl} extension="docx" />;
  })();
}

export { WordViewer };
